import { once } from 'underscore'
import { sendBeacon, systemError } from './Errors'


const reportSystemErrorOnceToRollbar = once(
    (error: Error) => systemError(error)
)

const reportWarningOnceToRollbar = once(
    () => {
        const message = `Persistent storage not granted.`
        console.warn(message)
        sendBeacon(message, {})
    }
)

const reportLogOnce = once(
    (message: string) => {
        console.log(message)
    }
)

/** Request persistent storage */
export async function requestPersistentStorage() {
    let isPersistent = await navigator.storage?.persisted?.()
    if (isPersistent) {
        return true
    }
    try {
        isPersistent = await navigator.storage?.persist?.()
        if (isPersistent) {
            reportLogOnce('Persistent storage granted')
        } else {
            if (import.meta.env.MODE === 'development') {
                // don't care about development mode
            } else {
                reportWarningOnceToRollbar()
            }
        }
        return isPersistent
    } catch (error) {
        reportSystemErrorOnceToRollbar(error as Error)
        return false
    }
}
